<lcs-loading-overlay
   class="flex-dir-col"
   [show]="callState | lcsCallState : 'loading'"
   *ndtErrorPage="!(callState | lcsCallState : 'error'); entityName: 'User'"
>
   <div class="detail-page-headerbar">
      <div class="left">
         <div class="page-heading">
            <h2 class="page-title">User - {{ user?.name }}</h2>
         </div>
      </div>
      <div class="right context-actions">
         <button
            type="button"
            mat-button
            [matMenuTriggerFor]="updateDetailsMenu"
            matTooltip="Info"
            aria-label="Prompt Info"
            id="extension-detail-info"
         >
            <mat-icon>info</mat-icon>
         </button>
         @if (userPrivileges?.canDelete) {
         <button
            type="button"
            mat-button
            class="user-actions-button"
            [matMenuTriggerFor]="userMenu"
            aria-label="User Actions"
            matTooltip="More Actions"
            id="user-detail-more-actions"
         >
            <mat-icon>more_horiz</mat-icon>
         </button>
         }
      </div>
   </div>
   <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <ndt-two-column-layout>
         <div ndtLeftColumn>
            <div class="details-wrapper">
               <ng-container>
                  <h5>Username</h5>
                  <div class="detail-item left-panel-text">{{ user?.username ? user?.username : 'N/A' }}</div>
               </ng-container>
               <ng-container>
                  <h5>Account</h5>
                  <div class="detail-item left-panel-text">{{ user?.account?.name ? user?.account?.name : 'N/A' }}</div>
               </ng-container>
               <ng-container>
                  <h5>Extension</h5>
                  <div class="detail-item">{{ user?.extension?.name ? user?.extension?.name : 'N/A' }}</div>
               </ng-container>
               @if (user?.isLocked || user?.isForcePasswordChange) {
               <h5>Additional Information</h5>
               @if (user?.isLocked) {
               <div class="detail-item alert-text"
                  >User locked on
                  {{ user?.lockoutDate ? (user?.lockoutDate | date : 'MM/dd/yyyy hh:mm aa') : 'N/A' }}</div
               >
               } } @if (user?.isForcePasswordChange) {
               <div class="detail-item alert-text">User is required to change their password on next login</div>
               <div class="detail-item"
                  >Last password change:
                  {{
                     user?.lastPasswordChangeDate
                        ? (user?.lastPasswordChangeDate | date : 'MM/dd/yyyy hh:mm aa')
                        : 'N/A'
                  }}</div
               >
               }
            </div>
         </div>
         <div ndtRightColumn>
            <mat-tab-group
               class="detail-tab-group"
               [(selectedIndex)]="selectedIndex"
               ndt-tab-router
               [loadSuccess$]="loadSuccess$"
               [useTimeout]="false"
            >
               <mat-tab [label]="'User Details'">
                  <div class="mat-tab-indented">
                     <div class="detail-right-column">
                        <mat-form-field class="flex-half">
                           <mat-label>Name</mat-label>
                           <input matInput autocomplete="off" type="text" [value]="user?.name" formControlName="name" />
                           @if (form.get('name')?.hasError('noContent') || form.get('name')?.hasError('required')) {
                           <mat-error> Name is Required. </mat-error>
                           } @if (form.get('name')?.hasError('max')) {
                           <mat-error> Name must be under 255 characters </mat-error>
                           }
                        </mat-form-field>
                        <mat-form-field class="flex-half">
                           <mat-label>Email</mat-label>
                           <input
                              matInput
                              autocomplete="off"
                              type="text"
                              [value]="user?.emailAddress"
                              formControlName="emailAddress"
                           />
                           @if (form.get('emailAddress')?.hasError('required')) {
                           <mat-error> Email is Required. </mat-error>
                           } @if (form.get('emailAddress')?.hasError('pattern')) {
                           <mat-error> Invalid Email </mat-error>
                           }
                        </mat-form-field>

                        @if (!isOnSystemPage && user?.account) {
                        <mat-form-field class="flex-full">
                           <mat-label>Extension</mat-label>
                           <input
                              [lcsSingleSelect]="extensionSelect"
                              [accountId]="user.account.accountId"
                              ndtExtensionSelect
                              type="text"
                              formControlName="extension"
                              [extensionTypesToExclude]="[7]"
                           />
                           <ndt-extension-select #extensionSelect [isIncludeEmptyOption]="true"></ndt-extension-select>
                        </mat-form-field>
                        }
                        <div class="flex-half role-multi-select">
                           <ndt-role-advanced-multi-select
                              [accountIdFilter]="isOnSystemPage ? null : user?.account?.accountId"
                              [itemsControl]="form.controls.roles"
                              (change)="emitRoleChange()"
                           ></ndt-role-advanced-multi-select>
                        </div>

                        <mat-checkbox class="flex-full" [checked]="user?.isActive" formControlName="isActive"
                           >Is Active</mat-checkbox
                        >
                        @if (isOnSystemPage) {
                        <mat-checkbox class="flex-full" [checked]="user?.isSystemUser" formControlName="isSystemUser"
                           >Grant access to admin portal</mat-checkbox
                        >
                        } @if (isAdminUser || isSystemUser) {
                        <span>
                           <mat-checkbox class="flex-full" [checked]="user?.isAdmin" formControlName="isAdmin"
                              >Is Admin</mat-checkbox
                           ><mat-icon
                              class="tooltip"
                              [appTooltip]="
                                 'Making a user Admin does not grant\n' +
                                 ' any privileges immediately, but any\n' +
                                 ' new privilege will be automatically\n' +
                                 ' granted for that user.'
                              "
                              >help</mat-icon
                           >
                        </span>
                        }
                     </div>
                  </div>
               </mat-tab>
               <mat-tab [label]="'Privileges'">
                  @if (privileges && user) {
                  <div class="mat-tab-indented user-privilege-tab">
                     <ndt-privileges-list
                        [privileges]="privileges"
                        [userRoles]="this.user.rolesConnection.items"
                        formGroupName="userPrivileges"
                        [isOnSystemPage]="isOnSystemPage"
                     ></ndt-privileges-list>
                  </div>
                  }
               </mat-tab>
               <mat-tab [label]="'Reports'">
                  <div class="mat-tab-indented">
                     <div class="detail-right-column">
                        <ng-template matTabContent>
                           <ndt-report-permissions-list-view
                              [name]="'reports'"
                              [userReports]="user.userReports"
                              [isOnSystemPage]="isOnSystemPage"
                              [isForUserReports]="true"
                              formControlName="userReports"
                              [userRoles]="user?.rolesConnection.items"
                              (reportsChange)="handleReportsChange($event)"
                           ></ndt-report-permissions-list-view>
                        </ng-template>
                     </div>
                  </div>
               </mat-tab>
               @if (!isOnSystemPage) {
               <mat-tab [label]="'Recordings'">
                  <div class="mat-tab-indented recording-permission-tab-body">
                     <ndt-call-recording-extensions-list
                        formControlName="userRecordingExtensions"
                        [extensions]="extensions"
                        [extensionGroups]="extensionGroups"
                        [userRoles]="this.user?.rolesConnection?.items"
                     ></ndt-call-recording-extensions-list>
                  </div>
               </mat-tab>
               }
            </mat-tab-group>
         </div>
      </ndt-two-column-layout>
      <ndt-form-footer (cancel)="onCancel()" [visible]="form.dirty" [callState]="callState"></ndt-form-footer>
   </form>
</lcs-loading-overlay>
<mat-menu #userMenu="matMenu">
   @if (userPrivileges?.canEdit && user?.isLocked) {
   <button mat-menu-item type="button" (click)="onUnlockUserAccount()" id="menu-user-unlock"> Unlock Account </button>
   } @if (!user?.lastLoggedIn && userPrivileges?.canAdd) {
   <button mat-menu-item type="button" (click)="onResendVerificationEmailClick()" id="menu-resend-verification">
      Resend Verification Email
   </button>
   } @if (userPrivileges?.canDelete) {
   <button mat-menu-item type="button" (click)="onDeleteClick()" id="menu-user-delete"> Delete </button>
   }
</mat-menu>
<mat-menu #updateDetailsMenu="matMenu">
   <update-details
      [createUser]="user?.createUser"
      [createDate]="user?.createDate"
      [updateUser]="user?.updateUser"
      [updateDate]="user?.updateDate"
   ></update-details>
</mat-menu>
